var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "icon-columns__container" }, [
    _c(
      "div",
      { staticClass: "container icon-columns" },
      [
        _c("h2", { staticClass: "icon-columns__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm.subheading
          ? _c("p", { staticClass: "icon-columns__subheading" }, [
              _vm._v(_vm._s(_vm.subheading)),
            ])
          : _vm._e(),
        _c("div", { staticClass: "icon-columns__link" }, [
          _vm.topLinkText
            ? _c(
                "a",
                { staticClass: "u-link", attrs: { href: _vm.topLinkUrl } },
                [_vm._v(_vm._s(_vm.topLinkText))]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "icon-columns__blocks" },
          [_vm._t("default")],
          2
        ),
        _vm.bottomButtonText
          ? _c("LinkButton", {
              staticClass: "icon-columns__button",
              attrs: { label: _vm.bottomButtonText, href: _vm.bottomButtonUrl },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }